import { render, staticRenderFns } from "./popupAlterarDatas.vue?vue&type=template&id=d615729c"
import script from "./popupAlterarDatas.vue?vue&type=script&lang=js"
export * from "./popupAlterarDatas.vue?vue&type=script&lang=js"
import style0 from "./popupAlterarDatas.vue?vue&type=style&index=0&id=d615729c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports